<app-timeline-detail [timeline]="timelineItems" [isChaseTimeline]="true"></app-timeline-detail>